module.exports = __webpack_public_path__ + "static/media/demographic-analysismarketing.4251a9be.svg";